import { FilterFormProps } from "../types";


export const cronJobValidationScheme = (values : FilterFormProps) => {
    let errors :any= {};
  
    const {dateRange} = values;
   
        if (!dateRange.startDate && !dateRange.endDate) {
            errors.dateRange = "Geçerli bir tarih aralığı giriniz";
        }else if (!dateRange.startDate) {
            errors.dateRange = "Geçerli bir başlangıç tarihi giriniz";
        }else
        if (!dateRange.endDate) {
            errors.dateRange = "Geçerli bir bitiş tarihi giriniz";
        } 
  
    
 
    return errors;
  };
  